import {
  GenerateTaskTemplateDocumentPreviewArg,
  TaskRouteDocumentPreviewWithParametersArg,
} from './api';
import { internalApiClient } from './client';

export async function fetchGeneratedTaskTemplateDocumentPreview(
  params: GenerateTaskTemplateDocumentPreviewArg,
) {
  try {
    const response = await internalApiClient.post(
      '/v1/task-template/vacation/document/preview',
      params,
      {
        responseType: 'blob',
      },
    );

    return response.data as Blob;
  } catch (error) {
    console.error(error);

    return null;
  }
}

const fetchBlob = async (url: string) => {
  try {
    const response = await internalApiClient({
      url,
      responseType: 'blob',
    });

    return response.data as Blob;
  } catch (error) {
    console.error(error);

    return null;
  }
};

export const fetchOrderDocumentPreview = async (
  args: TaskRouteDocumentPreviewWithParametersArg,
) => {
  try {
    const response = await internalApiClient({
      url: buildTaskRouteDocumentPreviewUrl(args.taskId, args.routeId),
      responseType: 'blob',
      method: 'POST',
      data: args.sendTaskDocumentSerializer,
    });

    return response.data as Blob;
  } catch (error) {
    console.error(error);

    return null;
  }
};

export const buildTaskRouteDocumentPreviewUrl = (
  taskId: string,
  routeId: string,
) => `/v1/task/${taskId}/route/${routeId}/preview`;

export async function fetchTaskRouteDocumentPreview(
  taskId: string,
  routeId: string,
) {
  return fetchBlob(buildTaskRouteDocumentPreviewUrl(taskId, routeId));
}

export const buildTaskDocumentPreviewUrl = (
  taskId: string,
  documentId: string,
) => `/v1/task/${taskId}/document/${documentId}/preview`;

export async function fetchTaskDocumentPreview(
  taskId: string,
  routeId: string,
) {
  return fetchBlob(buildTaskDocumentPreviewUrl(taskId, routeId));
}

export const buildFilePreviewUrl = (fileId: string) => `/v1/files/${fileId}`;

export async function fetchFilePreview(fileId: string) {
  return fetchBlob(buildFilePreviewUrl(fileId));
}
